export default __webpack_public_path__ + "static/media/mastercard.e7622b29.svg";